import React from 'react'
import { CheckoutSection, formatMoney } from '../../components'
import { translateResourceString } from '../../../util/translationUtility';
import styles from './checkout.module.css';

const spinnerSpan = <span className="fa fa-spinner fa-spin" />;

const CheckoutSummary = (
  {
    summary: {
      ShippingMethod,
      ShippingTotal,
      SubTotal,
      Total,
      Currency,
      TaxTotal,
      DiscountTotal,
      HandlingTotal
    },
    isRefreshing
  }) => {
  const formatCurrency = formatMoney(Currency);
  const formatShippingTotal = shippingTotal => {
    if (shippingTotal === null) return translateResourceString("/Checkout/Summary/ShippingTBD");
    if (shippingTotal === 0) return translateResourceString("/Checkout/Summary/ShippingFree");
    return formatCurrency(shippingTotal || 0);
  };
  return (
    <CheckoutSection label='Summary' hidden={false}>
        {isRefreshing
              ? spinnerSpan
              : (
                  <table className={styles.summaryTable} style={{width: "100%"}}>
            <tbody>
            <tr className="subtotal">
              <td className="summary-label">
                {translateResourceString("/Checkout/Summary/SubtotalLabel")}
              </td>
              <td className="summary-amount">
                {formatCurrency(SubTotal)}
              </td>
            </tr>
            {DiscountTotal != null &&
                <tr className="discount">
                    <td className="summary-label">
                        Discount
                    </td>
                    <td className="summary-amount">
                        {formatCurrency(DiscountTotal)}
                    </td>
                </tr>
            }

            <tr className="shipping">
              <td className="summary-label">
                  {translateResourceString("/Checkout/Summary/ShippingLabel")}
                <div className={styles.shippingMethod}>
                  <em>{ShippingMethod}</em>
                </div>
              </td>
              <td className="summary-amount">
                {formatShippingTotal(ShippingTotal)}
              </td>
            </tr>

            {HandlingTotal != null &&
                <tr className="handling">
                  <td className="summary-label">
                  {translateResourceString("/Checkout/Summary/TotalHandlingLabel")}
                 </td>
                  <td className="summary-amount">
                    {formatCurrency(HandlingTotal)}
                  </td>
                </tr>
            }
            {TaxTotal != null &&
                <tr className="tax">
                    <td className="summary-label">
                        {translateResourceString("/Checkout/Summary/TaxLabel")}
                    </td>
                    <td className="summary-amount">
                        {formatCurrency(TaxTotal)}
                    </td>
                </tr>
            }
            <tr className={styles.total}>
              <td className="total-label">
                  {translateResourceString("/Checkout/Summary/TotalLabel")}
              </td>
              <td className="total-amount">
                {formatCurrency(Total)}
              </td>
            </tr>
            </tbody>
          </table>)}
    </CheckoutSection>
  );
}

export default CheckoutSummary
